import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useSetDocumentTitle = (): void => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('sessions.siteTitle');
  }, [t]);
};
